import React, { useState } from "react";
import Style from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb, Button, Card, Tooltip } from "antd";
import { useHistory, useParams } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import NavBar from "./components/NavBar";
import PlayBack from "./components/PlayBack";
import MainScreen from "./components/MainScreen";
import ThreeSplitScreen from "./components/ThreeSplitScreen";
import LiveStatistics from "./components/LiveStatistics";
import useCurrentDate from "utils/useCurrentDate";

export default function PageLiveRecord() {
    const history = useHistory();
    const { courseNo, courseSeq, courseName, channelId } =
        useParams<StringMap>();
    const { batchNo } = useCurrentDate();
    const [mark, setMark] = useState<number>(1); //默认选中直播回放tab

    const title = (
        <div className={Style.head}>
            <div>
                <Tooltip title={courseName} placement="bottomLeft">
                    <span className={Style.courseTitle}>{courseName}</span>
                </Tooltip>
                <Button
                    size="small"
                    className={Style.goBack}
                    onClick={() => history.goBack()}>
                    <BiUndo size={16} />
                    返回
                </Button>
            </div>
        </div>
    );

    return (
        <div id="scroll1">
            <Header />

            <div className={Style.root}>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a href="">直播记录 </a>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Card
                    title={title}
                    bordered={false}
                    className={Style.container}>
                    <div className={Style.head}>
                        <div className={Style.subTitle}>
                            <span>编号 {courseNo}</span>
                            <span>序号 {courseSeq}</span>
                        </div>
                    </div>

                    <NavBar
                        mark={mark}
                        onChange={(val: number) => setMark(val)}
                    />

                    <div className={Style.content}>
                        {mark === 0 && (
                            <PlayBack
                                courseNo={courseNo}
                                courseSeq={courseSeq}
                            />
                        )}
                        {mark === 1 && (
                            <MainScreen
                                listData={{
                                    type: String(mark),
                                    courseNo: courseNo,
                                    courseName: courseName,
                                    batchNo: batchNo,
                                    courseSeq: courseSeq
                                }}
                            />
                        )}
                        {mark === 2 && (
                            <ThreeSplitScreen
                                listData={{
                                    type: String(mark),
                                    courseNo: courseNo,
                                    courseName: courseName,
                                    batchNo: batchNo,
                                    courseSeq: courseSeq
                                }}
                            />
                        )}
                        {mark === 3 && (
                            <LiveStatistics
                                courseSeq={courseSeq}
                                channelId={channelId}
                            />
                        )}
                    </div>
                </Card>
            </div>
        </div>
    );
}
